<template>
  <v-main>
    <v-container fluid>
      <v-row class="h100">
        <v-col cols="auto" class="pa-0">
          <SideBar />
        </v-col>
        <v-col xs="12">
          <v-row class="mb-5 h5">
            <Header />
          </v-row>
          <router-view :key="$route.fullPath" />
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script lang="ts">
import Vue from "vue";
import Header from "@/components/header/Header.vue";
import SideBar from "@/components/SideBar.vue";

export default Vue.extend({
  name: "ContentView",
  data() {
    return {};
  },
  components: {
    Header,
    SideBar,
  },
  computed: {
    expand() {
      return this.$store.getters.getDisplayExpand;
    },
  },
  created() {
    this.$store.dispatch("Users/refreshToken");
    this.$store.dispatch("Plans/fetchDeviceList");
    this.$store.dispatch("Plans/fetchCountryList");
  },
});
</script>
